// extracted by mini-css-extract-plugin
export default {"contentContainer":"styles_contentContainer__cwRZo","logo":"styles_logo__1w1kN","textWrapper":"styles_textWrapper__iLssL","image":"styles_image__l0PbW"};